module.exports = __webpack_public_path__ + "img/body-1.a20287f6.png";